import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
// import { Http, RequestOptions, URLSearchParams, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
//import { AutoLogoutService } from './services/auto-logout.service';
import { environment } from '../environments/environment';
import { BehaviorSubject } from 'rxjs';


@Injectable()

export class ApiserviceService {
  public httpOptions;
  public status;
  public device: any;
  public ip: any ='';
  public user_id: any;

  public user_token: string = '';
  public city_id: any = 'null';
  public session_id: string = 'null';
  public language: number;
  public language_list = [];
  public property_type_list = [];
  public entity_type_list = [];
  public allowResources = [];
  public city_code = '';
  public umsUrl = null;
  //  public estUrl = null
  public gisUrl = null;
  public gmsUrl = null;
  public gpsUrl = null;
  public gesUrl = null;
  public gmusUrl = null;
  public wms_url = null;
  public gisServiceUrl = null;
  private API_KEY = "7kjghhjj";
  isMobile: boolean;
  public user_name =  new BehaviorSubject<any>(localStorage.getItem('user_name'));
  public profile_image =  new BehaviorSubject<any>(localStorage.getItem('profile_image'));

  // set url of api
  setApiUrl() {
    this.umsUrl = environment.umsUrl;
    this.gisUrl = environment.gisUrl;
    this.gmsUrl = environment.gmsUrl;
    this.gpsUrl = environment.gpsUrl;
    this.gesUrl = environment.gesUrl;
    this.gmusUrl = environment.gmusUrl;
    this.gisServiceUrl = environment.gisServiceUrl;
    // this.wms_url = "http://est.dev10.in/geoserver/gisdb/wms?";
    this.user_token = (this.user_token == '') ? environment.user_token : this.user_token;
  }

  constructor(private http: HttpClient, private route: Router, private deviceInfo: DeviceDetectorService) {
    this.isMobile = this.deviceInfo.isMobile();
    this.setApiUrl();
    this.language = 1;
    if (localStorage.getItem('language_id')) {
      this.language = +localStorage.getItem('language_id');
    }
    this.getIpAddress();
    if (localStorage.getItem('device')) {
      this.device = JSON.parse(localStorage.getItem('device'));
    } else {
      this.device = this.getDevice();
      localStorage.setItem('device', JSON.stringify(this.device));
    }
    if (localStorage.getItem("ip")) {
      this.ip = localStorage.getItem("ip");
    } else {
      this.getIpAddress();
    }
    this.user_id = localStorage.getItem('user_id');
    if (localStorage.getItem('user_token')) this.user_token = localStorage.getItem('user_token');
    if (localStorage.getItem('city_id')) this.city_id = localStorage.getItem('city_id');
    if (localStorage.getItem('city_code')) this.city_code = localStorage.getItem('city_code');
    if (localStorage.getItem('session_id')) {
      this.session_id = localStorage.getItem('session_id');
    }
    this.getLanguageList();
    if (this.user_id && this.city_id) {
      // this.getUserDetail(this.user_id);
    }

  }


  // my external ip
  getIpAddress() {
    this.http.get('https://api.ipify.org/?format=json')
      .subscribe((data: any) => {
        let ip_details: any = data;
        this.ip = ip_details.ip;
        localStorage.setItem('ip', this.ip);
      });
  }
  // get device info
  getDevice() {
    let device = this.deviceInfo.getDeviceInfo();
    return device;
  }

  // setting header for UMS
  setUmsHeader(content_type = 'application/json') {
    // let dInfo = this.device.browser + ' ' + this.device.browser_version + ' (' + this.device.os + ')';
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', content_type);
    headers = headers.append('app-id', '9');
    // headers = headers.append('User-Device', dInfo);
    headers = headers.append('user-lang', 'en-us');
    //headers = headers.append('session-id', this.session_id);
    headers = headers.append('city-id', String(this.city_id));
    // if (localStorage.getItem('ip')) {
    //   headers = headers.append('User-Ip', this.ip);
    // } else {
    //   headers = headers.append('User-Ip', '::');
    // }
    headers = headers.append('user-token', String(this.user_token));
    this.httpOptions = { headers: headers };
  }

  // setting header for gis
  setGisHeader() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('API-KEY', this.API_KEY);
    headers = headers.append('USER-LANGUAGE', '1');
    headers = headers.append('USER-CITY', String(this.city_code));
    headers = headers.append('user-token', String(this.user_token));
    // headers = headers.append('session-id', this.session_id);
    this.httpOptions = { headers: headers };
  }
  setGisAllHeader(city_id: any = this.city_id) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('API-KEY', this.API_KEY);
    headers = headers.append('USER-LANGUAGE', '1');
    headers = headers.append('USER-CITY', String(city_id || this.city_id));
    headers = headers.append('user-token', String(this.user_token));
    // headers = headers.append('session-id', this.session_id);
    this.httpOptions = { headers: headers };
  }

  //Setting header for file upload
  setUploadHeader() {
    let headers = new HttpHeaders();
    headers = headers.append('API-KEY', this.API_KEY);
    headers = headers.append('USER-LANGUAGE', '1');
    headers = headers.append('USER-CITY', String(this.city_code));
    headers = headers.append('user-token', String(this.user_token));
    // headers = headers.append('session-id', this.session_id);
    this.httpOptions = { headers: headers };
  }

  setNewUploadHeader() {
    let headers = new HttpHeaders();
    headers = headers.append('API-KEY', this.API_KEY);
    headers = headers.append('USER-LANGUAGE', '1');
    headers = headers.append('USER-CITY', String(this.city_id));
    headers = headers.append('user-token', String(this.user_token));
    // headers = headers.append('session-id', this.session_id);
    this.httpOptions = { headers: headers };
  }

  setUploadHeaderUms(content_type = 'multipart/form-data', response_type) {
    let headers = new HttpHeaders();
    headers = headers.append('city-id', this.city_id.toString());
    headers = headers.append('USER-CITY', this.city_id.toString());
    headers = headers.append('CITY-CODE', this.city_code ? String(this.city_code):'');
    headers = headers.append('user-token', String(this.user_token));
    headers = headers.append('app-id', '9');
    headers = headers.append('user-lang', 'en-us');
    if (localStorage.getItem('ip')) {
      headers = headers.append('user-ip', String(this.ip));
    } else {
      headers = headers.append('user-ip', '::');
    }
    this.httpOptions = { headers: headers };
    if (response_type) {
      this.httpOptions['responseType'] = response_type;
    }
  }
  setUploadHeaderGis(content_type = 'application/json', response_type) {
    let headers = new HttpHeaders();

    if (content_type != 'no-content') {
      headers = headers.append('Content_type', content_type);
    }
    headers = headers.append('API-KEY', this.API_KEY);
    headers = headers.append('USER-CITY', String(this.city_code));
    headers = headers.append('user-token', String(this.user_token));
    // headers = headers.append('session-id', this.session_id);
    headers = headers.append('USER-LANGUAGE', '' + this.language + '');
    this.httpOptions = { headers: headers };
    if (response_type) {
      this.httpOptions['responseType'] = response_type;
    }

  }

  // get record using this function
  getUmsData(url) {
    this.setUmsHeader();
    return this.http.get(this.umsUrl + url, this.httpOptions)
    // .map(data => data.json());
  }


  // get record of gis
  // getGisData(url) {
  //   this.setGisHeader();
  //   return this.http.get(this.gisUrl + url, this.httpOptions)
  //   // .map(data => data.json());
  // }
  getGmusData(url) {
    this.setGisAllHeader();
    return this.http.get(this.gmusUrl + url, this.httpOptions)
    // .map(data => data.json());
  }
  getGmsData(url) {
    this.setGisAllHeader();
    return this.http.get(this.gmsUrl + url, this.httpOptions)
    // .map(data => data.json());
  }
  getGpsData(url) {
    this.setGisAllHeader();
    return this.http.get(this.gpsUrl + url, this.httpOptions)
    // .map(data => data.json());
  }
    getGisServiceData(url) {
    this.setGisAllHeader();
    return this.http.get(this.gisServiceUrl + url, this.httpOptions)
    // .map(data => data.json());
  }
  getGesData(url, city_id?: any) {
  this.setGisAllHeader(city_id);  // Pass city_id if provided
  return this.http.get(this.gesUrl + url, this.httpOptions);
}


  // post record of gis
  // postGisData(url, body) {
  //   if (body === null || body === undefined) {
  //     throw new Error('Required parameter body was null or undefined when calling Api.');
  //   }
  //   this.setGisHeader();
  //   return this.http.post(this.gisUrl + url, body, this.httpOptions);
  // }
  postGmusData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.post(this.gmusUrl + url, body, this.httpOptions);
  }
  postGmsData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.post(this.gmsUrl + url, body, this.httpOptions);
  }
  postGpsData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.post(this.gpsUrl + url, body, this.httpOptions);
  }
  postGesData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.post(this.gesUrl + url, body, this.httpOptions);
  }

  // delete record of gis
  // deleteGisData(url) {
  //   this.setGisHeader();
  //   return this.http.delete(this.gisUrl + url, this.httpOptions);
  // }
  deleteGmusData(url) {
    this.setGisAllHeader();
    return this.http.delete(this.gmusUrl + url, this.httpOptions);
  }
  deleteGmsData(url) {
    this.setGisAllHeader();
    return this.http.delete(this.gmsUrl + url, this.httpOptions);
  }
  deleteGpsData(url) {
    this.setGisAllHeader();
    return this.http.delete(this.gpsUrl + url, this.httpOptions);
  }
  deleteGesData(url) {
    this.setGisAllHeader();
    return this.http.delete(this.gesUrl + url, this.httpOptions);
  }
  //Uploaded File action
  postUserAction(url, body) {
    this.setGisAllHeader();
    return this.http.post(this.gmusUrl + url, body, this.httpOptions);
  }

  postFile(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setNewUploadHeader();
    return this.http.post(this.gmusUrl + url, body, this.httpOptions);
  }

  //put GIS data
  // putGisData(url, body) {
  //   this.setGisHeader();
  //   return this.http.put(this.gisUrl + url, body, this.httpOptions);
  // }
  putGmusData(url, body) {
    this.setGisAllHeader();
    return this.http.put(this.gmusUrl + url, body, this.httpOptions);
  }
  putGmsData(url, body) {
    this.setGisAllHeader();
    return this.http.put(this.gmsUrl + url, body, this.httpOptions);
  }
  putGpsData(url, body) {
    this.setGisAllHeader();
    return this.http.put(this.gpsUrl + url, body, this.httpOptions);
  }
  putGesData(url, body) {
    this.setGisAllHeader();
    return this.http.put(this.gesUrl + url, body, this.httpOptions);
  }
    patchGisServiceData(url, body) {
    this.setGisAllHeader();
    return this.http.patch(this.gisServiceUrl + url, body, this.httpOptions);
  }


  // send a POST request to the API to create a data object
  postUmsData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setUmsHeader();
    return this.http.post(this.umsUrl + url, body, this.httpOptions);
  }


  // send a PATCH request to the API to update a data object
  patchUmsData(urlWithId, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setUmsHeader();
    return this.http.patch(this.umsUrl + urlWithId, body, this.httpOptions);
  }

  postFileUms(url, body, response_type = null) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setUploadHeaderUms('application/json', response_type);
    return this.http.post(this.umsUrl + url, body, this.httpOptions);
  }

  // send a DELETE request to the API to delete a data object
  deleteUmsData(urlWithId) {
    this.setUmsHeader();
    return this.http.delete(this.umsUrl + urlWithId, this.httpOptions);
  }

  // getting list of property type
  getLanguageList() {
    this.getUmsData('language')
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            res.data.forEach(element => {
              if (element.status == 1) {
                this.language_list.push(element);
              }
            });
          }
        }
      );
  }

  // getting allow resources
  // getting allow resources
  getAllowResources() {
    let body = `user/resource?place_id=${this.city_id}&user_id=${this.user_id}`
    this.getUmsData(body)
      // .map(data => data.json())
      .subscribe(
        (data: any) => {
          this.allowResources = data.data;
        },
        err => {
        }
      )
  }

  logout(val) {
    if(environment.isLocalServe  || this.isMobile){
    this.getUmsData('logout?all_device='+val).subscribe(data => {});
      localStorage.clear();
      this.user_id = 'null';
      this.city_id = 'null';
      this.user_token = 'null';
      this.session_id = 'null';
      this.user_name.next('')
      this.route.navigateByUrl('/admin/login');
    }else{
      localStorage.clear();
      this.user_id = 'null';
      this.city_id = 'null';
      this.user_token = 'null';
      this.user_name.next('')
      this.session_id = 'null';
      let newwindow = window.open(`${environment.adminHost}/logout?continue=${environment.baseURL}&all_device=${val}`, '_self');
      if (window.focus) {newwindow.focus()}
    }
  }

  // checkRole(role) {
  //   let status = false;
  //   let roles = localStorage.getItem('roles');
  //   if (roles) {
  //     let roles_arr = [];
  //     roles_arr = roles.split(',');
  //     if (roles_arr.includes(role)) status = true;
  //   }
  //   return status;
  // }

  getUserRole() {
    let url = `users?user_ids=${this.user_id}`;
    this.getUmsData(url)
      .subscribe((data: any) => {
        if (data) {
          let val = data.data;
          let roles = val[0].role_names;
          localStorage.setItem('roles', roles);
        }
      })
  }

  getUserDetail(id) {
    this.getUmsData(`user?user_id=${id}`).subscribe((res: any) => {
      if (res.data) {
        this.setUser_info(res.data);
      }
    }, err => {
    })
  }

  setUser_info(userdata) {
    let image = 'assets/images/user.png';
      if (userdata.profile_image) {
        image = userdata.profile_image;
      }
      localStorage.setItem('profile_image', image);
      this.profile_image.next(image);
      let name='';
      if (userdata.user_details['1'].first_name) {
          name = userdata.user_details['1'].first_name;
      }
      if (userdata.user_details['1'].last_name) {
          name += " " +  userdata.user_details['1'].last_name;
      }
      localStorage.setItem('user_name', name);
      let user_info = {
          "fname": userdata.user_details['1'].first_name,
          "lname": userdata.user_details['1'].last_name,
          "contact": userdata.phone_number,
          "country": userdata.nationality,
          "email": userdata.primary_email_id,
          "language": 'en',
          "imageURL": userdata.profile_image
      }
      localStorage.setItem('user_info', JSON.stringify(user_info));
      this.user_name.next(name);
  }

  postMedia(url, body, response_type = null) {
    //concole.log('url==' + url);

    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setUploadHeaderGis('no-content', response_type);
    return this.http.post(this.gisUrl + url, body, this.httpOptions);
  }
  patchData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.patch(this.gmusUrl + url, body, this.httpOptions);
  }
  patchGmsData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.patch(this.gmsUrl + url, body, this.httpOptions);
  }
  patchGmusData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.patch(this.gmusUrl + url, body, this.httpOptions);
  }
  patchGpsData(url, body) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setGisAllHeader();
    return this.http.put(this.gpsUrl + url, body, this.httpOptions);
  }
  patchGesData(url: string, body: any, city_id?: any) {
  if (body === null || body === undefined) {
    throw new Error('Body is required');
  }
  this.setGisAllHeader(city_id);
  return this.http.patch(this.gesUrl + url, body, this.httpOptions);
}

  //ums upload media
  postUmsMedia(url, body, response_type = null) {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Api.');
    }
    this.setUploadHeaderUms('no-content', response_type);
    return this.http.post(this.umsUrl + url, body, this.httpOptions);
  }
}
